import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { AuthenticationGuard } from './service/authentication.guard';
import { LoginGuard } from './service/login.guard';
import { MainComponent } from './components/main/main.component';
import { PositionResolver } from './service/position.resolver';

const routes: Routes = [
  {
    component: LoginComponent,
    path: 'login',
    canActivate: [LoginGuard],
  },
  {
    component: MainComponent,
    path: 'positions',
    canActivate: [AuthenticationGuard],
    resolve: {
      preload: PositionResolver,
    },
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
